'use client';

interface ModalSSOProps {
  iframeParentBaseURL: string;
}

export const ModalSSO = ({ iframeParentBaseURL }: ModalSSOProps) => {
  const ssoURL = `${process.env.NEXT_PUBLIC_SSO_ENDPOINT}?emb=1&continue=${encodeURI(iframeParentBaseURL)}`;

  return <iframe src={ssoURL} width='100%' height='100%' />;
};
